/* jshint esversion: 6, -W097 */
/* globals require, module */
'use strict';

const utilsModule = require('@utils/enerveeUtilsModule');
const accountModule = require('@app/components/account/accountModule');

// NOTE: this module doesn't really contain anything _yet_, but later core components should be
// included in this `enervee.core` module.
const coreModule = angular
    .module('enervee.core', [
        accountModule.name,
        utilsModule.name,
    ]);

// enerveeHeaderService (+dependencies)
require('@app/shared/enerveeHeader/enerveeHeaderService');

// routings dependencies

// configs dependencies
require('@app/components/account/accountSettings/accountSettingsDirective/accountSettingsService');
require('@app/components/account/accountRebates/accountRebatesService');
require('@app/components/account/accountSettings/accountService');
require('@app/components/account/accountEmailSettings/emailSettingsService');
require('@app/shared/integrations/enerveeCheckout/enerveeCheckoutService');

// general dependencies
require('@app/shared/adUnits/adUnitsDirective');
require('@app/shared/utils/goToSectionDirective');
require('@app/shared/utils/ngEnterDirective');
require('@app/shared/utils/onFormChangeDirective');
require('@app/shared/a11y/a11yTrapTabFocusDirective');
require('@app/shared/globalAlerts/globalAlertsDirective');

// enervee-header directive (+dependencies)
require('@app/shared/enerveeHeader/enerveeHeaderDirective');
require('@app/shared/integrations/enerveeRebate/enerveeRebateService');
require('@app/shared/cart/cartService');
require('@app/shared/cart/cartAnalyticsService');
require('@app/shared/popovers/popoverService');
require('@app/components/fastTrack/fastTrackModule');
require('@app/components/fastTrack/productsModal/fastTrackProductsModalService');
require('@app/components/fastTrack/uploadReceiptsModal/fastTrackUploadReceiptsModalService');
require('@app/components/fastTrack/fastTrackModal/fastTrackModalService');
require('@app/components/fastTrack/fastTrackButtonDirective');
require('@app/components/fastTrack/header/headerDirective');
require('@app/components/fastTrack/productsModal/fastTrackProductsModalController');
require('@app/components/fastTrack/errorsModal/fastTrackErrorsModalController');
require('@app/components/fastTrack/successModal/fastTrackSuccessModalController');
require('@app/components/fastTrack/uploadReceiptsModal/fastTrackUploadReceiptsModalController');
require('@app/components/fastTrack/uploadReceiptsModal/fastTrackCartItem/fastTrackCartItemDirective');
require('@app/components/fastTrack/uploadReceiptsModal/fastTrackReceiptUploader/fastTrackReceiptUploaderDirective');
require('@app/components/fastTrack/waitingModal/fastTrackWaitingModalController');
require('@app/shared/search/searchBoxDirective');
require('@app/shared/modals/utilityRateZipCodeSelector/zipCodeSelectorDirective');
require('@app/shared/utilityStateSelector/utilityStateSelectorDirective');
require('@app/shared/mobileNav/mobileNavDirective');
require('@app/shared/productLandingPage/productLandingPageDirective');
require('@app/shared/productLandingPage/productLandingPageService');

// error + support pages
require('@app/shared/errorPages/errorPagesController');
require('@app/components/support/supportPageController');

// modals
require('@app/shared/search/autocomplete/autocompleteDirective');
require('@app/shared/gdpr/gdprService');
require('@app/shared/modals/forgotPassword/forgotPasswordService');
require('@app/shared/modals/changePassword/changePasswordService');
require('@app/shared/modals/deleteAccount/deleteAccountService');
require('@app/shared/modals/welcome/welcomeModalService');
require('@app/shared/modals/signup/signupDirective');
require('@app/shared/modals/login/loginDirective');
require('@app/shared/modals/welcome/welcomeModalDirective');
require('@app/shared/modals/resetPasswordLink/resetPasswordLinkDirective');
require('@app/shared/modals/forgotPassword/forgotPasswordDirective');
require('@app/shared/modals/changePassword/changePasswordDirective');
require('@app/shared/modals/moreInfo/moreInfoDirective');
require('@app/shared/modals/deleteAccount/deleteAccountDirective');
require('@app/shared/modals/rebates/rebatesDirective');
require('@app/shared/modals/replaceCart/replaceCartDirective');
require('@app/shared/cart/cartDirective');
require('@app/shared/cart/cartItemDirective');
require('@app/shared/rebateReasons/rebateReasonsDirective');
require('@app/shared/productCard/checkoutPrice/checkoutPriceDirective');
require('@app/shared/integrations/googleApi/autocomplete/googleAutocompleteDirective');
require('@app/shared/calendar/calendarDirective');
require('@app/shared/integrations/enerveeRebate/rebateApplicationFormDirective');
require('@app/shared/inputs/dropdown/dropdownDirective');

// stuff required by more than one route
require('@app/pages/product/priceDrop/priceDropService');
require('@app/shared/integrations/enerveeCheckout/buyButton/checkoutBuyButtonDirective');
require('@app/shared/integrations/enerveeCheckout/addToCartButton/addToCartButtonDirective');

module.exports = coreModule;
